module.exports = __webpack_public_path__ + "img/nikko.fec79f2.png";